module.exports = __webpack_public_path__ + "static/media/1835.0af84902.jpg";